module.exports = __webpack_public_path__ + "static/media/macromakers.9f9c4886.webp";